import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { ProjectPortfolio } from './index'
import { usePortals } from './olivium/portal-factory/usePortalFactory'
import { getPortal, getPortalContext } from './olivium/portal-factory/portalFactory'

/**
 * V2 Projects Portfolio — route wrapper (PHASE_2M P1).
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/projects   (primary)
 *   /square/command-center-v2/projects        (alias → redirect)
 *
 * Honesty contract: the portfolio lists REAL sq_project_portals rows via
 * usePortals (live backend, applied 2026-07-10); expanding a row lazy-loads
 * the real detail + context. Registered projects (Arbuckle) and divisions
 * are code-registered surfaces. "Create Project" routes to the Portal
 * Factory create flow — the real, audited, receipted persistence path.
 * No demo rows, no local fake create.
 */
export default function SquareCodeProjectsRoute() {
  const navigate = useNavigate()
  const { portals, loading, error, authRequired } = usePortals()
  return (
    <ProjectPortfolio
      portals={portals}
      loading={loading}
      error={error}
      authRequired={authRequired}
      onOpen={(path) => navigate(path)}
      loadPortalSummary={async (id) => {
        const [detail, context] = await Promise.all([
          getPortal(id),
          getPortalContext(id).catch(() => null),
        ])
        return { detail, context }
      }}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
    />
  )
}
